'use strict';

require('../../style/index.less');

require('./index.less');

require('../../select/style');

require('../../checkbox/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/tree-select/style/index.js
 ** module id = 251
 ** module chunks = 0
 **/